/**
 * Константы для режима презентации
 */
export const PRESENTATION_CONSTANTS = {
    /** Коэффициент масштабирования при зуме */
    SCALE_BY: 1.1,
    /** Максимальный уровень зума */
    MAX_ZOOM: 20,
    /** Минимальный уровень зума (1 == 100% элемента) */
    MIN_ZOOM: 1,
    /** Размер элемента по умолчанию */
    DEFAULT_ELEMENT_SIZE: 64,
    /** Порог изменения позиции для отслеживания изменений */
    POSITION_CHANGE_THRESHOLD: 1,
    /** Порог изменения зума для отслеживания изменений */
    ZOOM_CHANGE_THRESHOLD: 0.01,
};
export const PRESENTATION_STYLES = {
    /** Стили для Stage презентации */
    STAGE: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: '#000',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'auto',
    },
    /** Стили для контейнера кнопок */
    BUTTONS_CONTAINER: {
        position: 'fixed',
        top: '20px',
        right: '20px',
        display: 'flex',
        flexDirection: 'row',
        gap: '10px',
        zIndex: 10000,
        pointerEvents: 'auto',
    },
    /** Стили для кнопки фуллскрина */
    FULLSCREEN_BUTTON: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '6px',
        width: '40px',
        height: '40px',
        backgroundColor: 'transparent',
        border: '0.5px solid rgba(54, 49, 61, 1)',
        borderRadius: '8px',
        cursor: 'pointer',
        pointerEvents: 'auto',
        transition: 'all 0.2s ease',
        backdropFilter: 'blur(10px)',
        opacity: 0.6,
        color: 'white',
    },
    /** Стили для hover состояния кнопки фуллскрина */
    FULLSCREEN_BUTTON_HOVER: {
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        borderColor: 'rgba(255, 255, 255, 0.5)',
        opacity: 1,
    },
    /** Стили для кнопки сброса */
    RESET_BUTTON: {
        backgroundColor: 'rgba(8, 2, 17, 0.6)',
        color: 'white',
        border: '0.5px solid rgba(54, 49, 61, 1)',
        borderRadius: '8px',
        padding: '8px 10px',
        fontSize: '0.7rem',
        fontWeight: '400',
        cursor: 'pointer',
        pointerEvents: 'auto',
        transition: 'all 0.2s ease',
        backdropFilter: 'blur(10px)',
    },
    /** Стили для hover состояния кнопки */
    RESET_BUTTON_HOVER: {
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        borderColor: 'rgba(255, 255, 255, 0.5)',
    },
};
